<template>
  <div class="api-line-char-cla">
    <chartTop v-model="time" :title="$t('statistics.apiStatistics')"></chartTop>
    <div class="statistics-chart-box-cla" id="aipLineChart">
      <zkLoading v-show="showLoad"></zkLoading>
    </div>
  </div>
</template>

<script>
import chartTop from './chartTop'
import { getLastTime } from '@/utils/utils.js'
import { getStatisticTotalTrend } from '@/services/statisticsApi.js'
import { getOptionConfig } from './apiLineChar.js'
var echarts = require('echarts')
export default {
  data() {
    return {
      time: 30,
      timeRange: [],
      dataList: [],
      showLoad: false
    }
  },
  components: {
    chartTop
  },
  watch: {
    time: {
      handler(newValue, oldValue) {
        if (newValue === 90) {
          // 最近三个月
          this.timeRange = getLastTime('months', 3)
        } else if (newValue === 30) {
          // 最近一个月个月
          this.timeRange = getLastTime('months', 1)
        } else {
          // 最近一周
          this.timeRange = getLastTime('days', 7)
        }
        this.getStatisticTotalTrend()
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    getStatisticTotalTrend() {
      let params = {
        startTime: this.timeRange[0],
        endTime: this.timeRange[1],
        appCode: 'DBS'
      }
      this.showLoad = true
      getStatisticTotalTrend(params)
        .then(data => {
          if (data.code === '00000000') {
            this.dataList = data.payload.data.innerList
            this.getOption()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.showLoad = false
        })
    },
    getOption() {
      let lang = {}
      let option = getOptionConfig(this.dataList, lang, this.time, this)
      this.renderChart(option)
    },
    renderChart(option) {
      if (!this.barChart) {
        this.barChart = echarts.init(document.getElementById('aipLineChart'))
        this.barChart.on('click', function(params) {})
      }
      this.barChart.setOption(option, true)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.api-line-char-cla {
  height: @statisticsChartHeight;
  background-color: #ffffff;
  border-radius: 4px;
  margin-left: 12px;
  flex-grow: 1;
}
@media screen and (max-width: 980px) {
  .api-line-char-cla {
    margin-left: 0px;
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/apiStatistics/apiLineChart.vue